import React, { FunctionComponent, ReactElement } from 'react';
import { Flex, Text } from '@bitrise/bitkit';
import { CrashStackTraceFrame, SupportedPlatforms } from '@trace/types';
import dataAtIds from '../../../../dataAtIds.json';

interface Props extends CrashStackTraceFrame {
  platform: SupportedPlatforms;
}

const frameFormatAndroid = ({
  filename,
  lineno,
  function: functionName,
  module,
}: CrashStackTraceFrame): ReactElement => {
  return (
    <Text monospace>
      {filename}:{lineno} {module}.{functionName}
    </Text>
  );
};

const frameFormatIos = ({
  filename,
  lineno,
  function: functionName,
  module,
}: CrashStackTraceFrame): ReactElement => {
  const moduleName = module?.split('/').pop() || '';
  const isMissing = !functionName && !filename;
  const partFilename = filename ? `${filename} - ` : '';
  const partLineNo = lineno && filename ? ` line ${lineno} -` : '';

  return (
    <>
      <Text inline>{moduleName}</Text>
      <Text inline monospace>
        {` `}- {isMissing ? ' missing' : `${partFilename} ${partLineNo} ${functionName}`}
      </Text>
    </>
  );
};

const frameFormatMap: Record<SupportedPlatforms, (frame: CrashStackTraceFrame) => ReactElement> = {
  android: frameFormatAndroid,
  ios: frameFormatIos,
};

const CrashStackTraceFrame: FunctionComponent<Props> = (props) => {
  const { platform, ...rest } = props;
  const frameText = frameFormatMap[platform](rest);

  return (
    <Flex
      className="CrashStackTrace__line"
      direction="horizontal"
      paddingHorizontal="x8"
      paddingVertical="x2"
      data-trace-at-id={dataAtIds.CrashPageReportStackTraceFrame}
    >
      <Flex grow initial="none">
        <Text breakOn="none" size="x2">
          {frameText}
        </Text>
      </Flex>
    </Flex>
  );
};

export default CrashStackTraceFrame;
